import { OrganizationSettings } from '@care-portals/api-interfaces';

export const getPatientPortalDomain = (
  organizationSettings: OrganizationSettings
) => {
  return (
    organizationSettings.newPatientPortalDomain ||
    organizationSettings.patientPortalDomain
  );
};

export const isLegacyPayment = (organizationSettings: OrganizationSettings) => {
  return !organizationSettings.newPatientPortalDomain;
};
